import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "../SubMenus/Garment.css";
import men1 from "../assets/menscollection.webp";
import woman1 from "../assets/woman.jpg";
import kids1 from "../assets/kids.jpg";
import children1 from "../assets/children.jpg";

const collections = [
  {
    title: "Men’s Collection",
    image: men1,
    link: "/products/garments/men",
  },
  {
    title: "Women’s Collection",
    image: woman1,
    link: "/products/garments/women",
  },
  {
    title: "Children Collection",
    image: kids1,
    link: "/products/garments/children",
  },
  {
    title: "Kids Collection",
    image: children1,
    link: "/products/garments/kids",
  },
];

export default function Garments() {
  return (
    <div className="products-container">
      <h2 className="products-heading">Our Collections</h2>
      <div className="products-grid">
        {collections.map((item, index) => (
            
          <motion.div
            key={index}
            className="product-card"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            
            <Link to={item.link}>
              <img src={item.image} alt={item.title} className="product-img" />
              <div className="product-overlay">
                <h3>{item.title}</h3>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
